import { base64Encode, base64Decode, getVendorAndEmailFromCookies } from './utilfunctions.js';
const contactFormEvents = (() => {
    const getCookie = (name) => {
      const match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
      return match ? match.pop() : '';
    };

    const isUserLoggedIn = () => !!getCookie('userAuth');

    const createField = ({ id, label, type = 'text', required = true, isTextArea = false }) => {
      return `
        <div class="contact-form-group" id="contact-group-${id}">
        <label for="${id}">${label}</label>
          <div class="contact-error-message" id="contact-${id}-error"></div>
          ${isTextArea
            ? `<textarea id="${id}" rows="5" ${required ? 'required' : ''}></textarea>`
            : `<input type="${type}" id="${id}" ${required ? 'required' : ''}>`}
        </div>`;
    };

    const init = () => {
      const form = document.getElementById('contactForm');
      const loggedIn = isUserLoggedIn();
      const user = loggedIn ? getVendorAndEmailFromCookies() : {};

      const fields = [];

      if (!loggedIn) {
        fields.push(
          { id: 'firstName', label: getI18n('first_name') },
          { id: 'lastName', label: getI18n('last_name') },
          { id: 'email', label: getI18n('email_address'), type: 'email' },
          { id: 'confirmEmail', label: getI18n('confirm_email'), type: 'email' }
        );
      }

      fields.push(
        { id: 'subject', label: getI18n('subject') },
        { id: 'message', label: getI18n('message'), isTextArea: true }
      );

      form.innerHTML = fields.map(createField).join('') + `
        <div id="contact-spinner-container" style="text-align:center; margin-top:10px;"></div>
      <button id="contact-submitBtn" type="button" disabled>${getI18n('send')}</button>
        <div id="contact-response-message" style="margin-top:15px; font-size:15px; text-align:center;"></div>
      `;

      const validations = {
      firstName: v => v.trim() ? '' : getI18n('first_name_required'),
      lastName: v => v.trim() ? '' : getI18n('last_name_required'),
      email: v => /^[^@]+@[^@]+\.[^@]+$/.test(v) ? '' : getI18n('enter_valid_email'),
      confirmEmail: v => v === document.getElementById('email')?.value ? '' : getI18n('emails_do_not_match'),
      subject: v => v.trim() ? '' : getI18n('subject_required'),
      message: v => v.trim() ? '' : getI18n('message_required')
      };

      const touchedFields = new Set();
      const allFieldIds = fields.map(f => f.id);

      const validateField = (id) => {
        const input = document.getElementById(id);
        const group = document.getElementById(`contact-group-${id}`);
        const errorDiv = document.getElementById(`contact-${id}-error`);
        const value = input.value;
        const error = validations[id]?.(value) || '';
        errorDiv.textContent = error;
        group.classList.toggle('contact-error', !!error);
        return !error;
      };

      const validateOnlyTouched = () => {
        let isValid = true;
        touchedFields.forEach(id => {
          if (!validateField(id)) isValid = false;
        });
        return isValid;
      };

      const validateAllFields = () => {
        return allFieldIds.every(id => {
          const input = document.getElementById(id);
          const validate = validations[id];
          return validate && validate(input.value) === '';
        });
      };

      const updateButtonState = () => {
        document.getElementById('contact-submitBtn').disabled = !validateAllFields();
      };

      allFieldIds.forEach(id => {
        const input = document.getElementById(id);
        input.addEventListener('focus', () => touchedFields.add(id));
        input.addEventListener('blur', () => {
          if (touchedFields.has(id)) {
            validateField(id);
            updateButtonState();
          }
        });
        input.addEventListener('input', () => {
          if (touchedFields.has(id)) {
            validateField(id);
            updateButtonState();
          }
        });
      });

      const submitButton = document.getElementById('contact-submitBtn');
      const spinnerContainer = document.getElementById('contact-spinner-container');
      const responseMessage = document.getElementById('contact-response-message');

      submitButton.addEventListener('click', async () => {
        allFieldIds.forEach(id => touchedFields.add(id));
        const isValid = validateOnlyTouched();
        updateButtonState();
        if (!isValid) return;

        submitButton.disabled = true;
        spinnerContainer.innerHTML = `
          <svg width="32" height="32" class="contact-spinner" style="color: var(--text-primary); animation: spin 1s linear infinite;">
            <use href="#icon-loading-spinner-color-overide"></use>
          </svg>

        `;
        responseMessage.textContent = '';

        const rawHost = window.location.hostname;
        const domain = rawHost.startsWith('www.') ? rawHost.substring(4) : rawHost;
        const locale = getLanguage();

        const data = {
          firstname: loggedIn ? user.firstname : document.getElementById('firstName').value,
          lastname: loggedIn ? user.lastname : document.getElementById('lastName').value,
          email: loggedIn ? user.email : document.getElementById('email').value,
          vendor: loggedIn ? user.vendor : '',
          subject: document.getElementById('subject').value,
          message: document.getElementById('message').value,
          locale: locale,
          domain: domain
        };

        //await new Promise(resolve => setTimeout(resolve, 50000));

        try {
          const res = await fetch(getApiUrl('contactusEmail', 'loginapi'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
          });

          const resData = await res.json();

          console.log('Parsed JSON Response:', resData);

          if (res.ok && resData.ticketNumber) {
          responseMessage.style.color = '#228B22';
          responseMessage.textContent = `${getI18n('success_message')} #${resData.ticketNumber}. ${getI18n('reply_time')}`;

            allFieldIds.forEach(id => {
                const input = document.getElementById(id);
                if (input) {
                  input.value = '';
                }
              });
            touchedFields.clear();
            updateButtonState();
          } else {
            throw new Error('Submission failed.');
          }
        } catch (err) {
          console.error('Fetch Error:', err);
          responseMessage.style.color = 'red';
        responseMessage.textContent = getI18n('error_submit');
        } finally {
          spinnerContainer.innerHTML = '';
          submitButton.disabled = false;
          scrollToTopWhenWindowScrolls();
        }
      });
    };

    return { init };
  })();

  export default contactFormEvents;
